export default __webpack_public_path__ + "static/media/25.5da594af.jpg";